import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {flowRight as compose} from 'lodash';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFileInvoice} from '@fortawesome/free-solid-svg-icons/faFileInvoice';
import {PageLayout} from '../../../common/look/ui-bootstrap/components';
import TabPage from '../../../common/components/layout/TabPage';
import {withRouter} from 'react-router';
import InvoicesAdmin from './InvoicesAdmin';
import Metadata from '../../../common/components/Metadata';
import SubscriptionsAdmin from './SubscriptionsAdmin';

const AdminBillingDetails = ({t}) => {
  const tabs = [
    {
      header: (
        <>
          <FontAwesomeIcon icon={faFileInvoice} color="rgb(201,0,95)"/>
          {` ${t('invoices')}`}
        </>
      ),
      content: <InvoicesAdmin />,
    },
    {
      header: (
        <>
          <FontAwesomeIcon icon={faFileInvoice} color="rgb(201,0,95)"/>
          {` ${t('subscriptions')}`}
        </>
      ),
      content: <SubscriptionsAdmin />,
    },
  ];

  return (
    <PageLayout>
      <Metadata meta={t('billing')} title={t('billing')}/>
      <TabPage tabs={tabs}/>
    </PageLayout>
  );
};

AdminBillingDetails.propTypes = {
  t: PropTypes.func.isRequired,
};

export default compose(
  withRouter,
  withTranslation('billing'),
)(AdminBillingDetails);
